import { render, staticRenderFns } from "./MTclosed.vue?vue&type=template&id=957f4a74&"
import script from "./MTclosed.vue?vue&type=script&lang=js&"
export * from "./MTclosed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports